"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _LayoutButtons = _interopRequireDefault(require("../Layout/LayoutButtons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    marginTop: theme.spacing(2),
    borderTop: "1px solid",
    borderColor: theme.palette.divider
  }
}));

const ModuleFooter = ({
  className,
  buttons = [],
  buttonGroupProps,
  buttonProps,
  children
}) => {
  const classes = useStyles();

  if (!buttons.length && !children) {
    return false;
  }

  if (children) {
    return _react.default.createElement("footer", {
      className: className || classes.root
    }, children);
  }

  return _react.default.createElement("footer", {
    className: className || classes.root
  }, buttons && _react.default.createElement(_LayoutButtons.default, {
    buttons: buttons,
    buttonGroupProps: buttonGroupProps,
    buttonProps: buttonProps
  }), children);
};

var _default = ModuleFooter;
exports.default = _default;
module.exports = exports.default;